import Typography from '@mui/material/Typography';
import Icon from '../Icon';
import { Container, TextWrapper } from './styles';
import type { ReactNode } from 'react';
import { Stack } from '@mui/material';
import { NEW_COLORS } from '../../themes/colors/newColors';

const ALERT_CARD_DATA = {
  success: {
    borderColor: NEW_COLORS.SEMANTICS.SUCCESS[800],
    backgroundColor: 'rgba(82, 135, 44, 0.04)',
    titleColor: NEW_COLORS.SEMANTICS.SUCCESS[800],
  },
  error: {
    borderColor: NEW_COLORS.SEMANTICS.ERROR[600],
    backgroundColor: 'rgba(201, 54, 0, 0.04)',
    titleColor: NEW_COLORS.SEMANTICS.ERROR[600],
  },
  info: {
    borderColor: NEW_COLORS.SEMANTICS.INFO[800],
    backgroundColor: 'rgba(0, 84, 184, 0.04)',
    titleColor: NEW_COLORS.PRIMARY[700],
  },
  alert: {
    borderColor: NEW_COLORS.SECONDARY[500],
    backgroundColor: 'rgba(255, 153, 0, 0.04)',
    titleColor: NEW_COLORS.SECONDARY[500],
  },
  warning: {
    borderColor: NEW_COLORS.SECONDARY[500],
    backgroundColor: NEW_COLORS.SECONDARY[25],
    titleColor: NEW_COLORS.SECONDARY[500],
  },
};

interface AlertCardProps {
  type: 'success' | 'error' | 'info' | 'alert' | 'warning';
  title?: string;
  content: string | React.JSX.Element;
  button?: ReactNode;
}

const AlertCard = ({ type, title, content, button }: AlertCardProps) => {
  return (
    <Container
      backgroundColor={ALERT_CARD_DATA[type].backgroundColor}
      borderColor={ALERT_CARD_DATA[type].borderColor}
      alignItems={title ? 'flex-start' : 'center'}
    >
      <Icon
        name={
          type === 'success'
            ? 'actions-b2b-check-circle-filled'
            : 'actions-b2b-alert-octagon-filled'
        }
        size={30}
        color={ALERT_CARD_DATA[type].titleColor}
      />
      <Stack flexDirection="row" alignItems="center" width="100%" gap={9}>
        <TextWrapper marginBottom={title ? 0.75 : 0}>
          {title && (
            <Typography
              variant="subtitle1"
              color={ALERT_CARD_DATA[type].titleColor}
            >
              {title}
            </Typography>
          )}
          {typeof content === 'string' ? (
            <Typography color={NEW_COLORS.GRAYSCALE[700]} variant="text">
              {content}
            </Typography>
          ) : (
            content
          )}
        </TextWrapper>
        {button}
      </Stack>
    </Container>
  );
};

export default AlertCard;
